import { useLayoutEffect, useState } from 'react';

/** 智能工具侧栏：万能改图 / 文生图共用 img2img；文生视频用 video-studio */
const SIDEBAR_SELECTOR = '.img2img-studio__sidebar, .video-studio__sidebar';

/**
 * 选用模板等侧栏：贴在功能页左侧参数栏右侧打开。
 * 返回相对视口的 left（px）；找不到侧栏时为 0。
 */
export default function useStudioSidebarDockLeft(enabled = true) {
  const [left, setLeft] = useState(0);

  useLayoutEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      setLeft(0);
      return undefined;
    }

    let frame = 0;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const el = document.querySelector(SIDEBAR_SELECTOR);
        if (!el) {
          setLeft(0);
          return;
        }
        setLeft(Math.max(0, Math.round(el.getBoundingClientRect().right)));
      });
    };

    measure();
    window.addEventListener('resize', measure);
    const el = document.querySelector(SIDEBAR_SELECTOR);
    const ro = typeof ResizeObserver !== 'undefined' && el
      ? new ResizeObserver(measure)
      : null;
    if (ro && el) ro.observe(el);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', measure);
      ro?.disconnect();
    };
  }, [enabled]);

  return left;
}
